import {PartnerDetail} from '../types/types';
import {IMAGE_BASE_URL} from "../constants/config.ts";
import '../scss/favourite-brand.scss';

interface Props {
  partner: PartnerDetail;
  handleLinkClick: (id: string) => void;
  handleRemoveClick: (id: string) => void;
  isRemovable: boolean;
}

const FavouriteBrand: React.FC<Props> = ({ partner, handleLinkClick, handleRemoveClick, isRemovable }) => {
  return (
    <section className="favourite-brand text-center">
      <div onClick={() => handleLinkClick(partner.id)}>
        {partner.image && (
          <img className="mb-2" width={70} height={70} src={`${IMAGE_BASE_URL}/${partner.image}`} alt={`${partner.name} logo`} />
        )}

        {!partner.image && <div className="favourite-brand__image-placeholder mb-2"></div>}

        <p className="mb-0 fz-14 font-yettel">
          {partner.name} ({partner.adCount})
        </p>
      </div>
      {isRemovable && <div onClick={() => handleRemoveClick(partner.id)} className="favourite-brand__remove"></div>}
    </section>
  );
};

export default FavouriteBrand;
